import SEO from "../../data/seo";
import HeaderTwo from "../../layout/headers/header-two";
import BreadCrumb from "../common/breadcrumb";
import FooterOne from "../../layout/footers/footer-one";
import AboutMain from "./about";

// Fixed the image path depth as well!
import aboutBanner from "../../assets/img/banner/about-banner.jpeg";

const AboutUs = () => {
    return (
        <>
            <SEO pageTitle="About Us | Arclight Developers" />
            <HeaderTwo />
            
            <BreadCrumb title="About Us" innerTitle="About Us" bgImage={aboutBanner} />
            
            <AboutMain />
            <FooterOne />    
        </>
    );
};

export default AboutUs;